var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dateSelection" }, [
    _c(
      "button",
      {
        class: ["custom-date-picker", { editable: !_vm.isReadOnly }],
        attrs: { id: "date-range-picker", tabindex: "0" },
        on: { click: _vm.openDateRangePicker },
      },
      [
        _c("i", { staticClass: "far fa-calendar-range" }),
        _vm._v(" \n    "),
        _c("span", { attrs: { id: "dateRangeLabel" } }, [
          _vm._v(_vm._s(_vm.dateText)),
        ]),
        _vm._v(" "),
        !_vm.isReadOnly
          ? _c("i", {
              class: {
                far: true,
                "fa-chevron-down": !_vm.showDateRangePicker,
                "fa-chevron-up": _vm.showDateRangePicker,
              },
            })
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showDateRangePicker,
            expression: "showDateRangePicker",
          },
        ],
        ref: "dateRangePicker",
        attrs: { id: "dateRangePicker" },
      },
      [
        _c("date-range-picker", {
          attrs: {
            "min-date": _vm.minDate,
            "max-date": _vm.maxDate,
            value: _vm.value,
          },
          on: { "range-selected": _vm.updateDateRange },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }